import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "Pathyacharya by Schooglink - बिहार बोर्ड, UP बोर्ड पढ़ाई ऐप | Hindi Medium",
  description = "Pathyacharya by Schooglink - बिहार बोर्ड, UP बोर्ड, झारखंड बोर्ड परीक्षा की तैयारी हिंदी में। Class 6-12 के लिए video lectures, AI doubt solving, daily quizzes। 7 दिन free trial।",
  url = "https://schooglink.com/",
  image = "https://schooglink.com/logo.png",
  jsonLd = null,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="hi_IN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
